module.exports = {"140929100":"岚漪镇","140929101":"三井镇","140929200":"神堂坪乡","140929201":"高家会乡","140929202":"李家沟乡","140929203":"水峪贯乡","140929204":"西豹峪乡","140929205":"温泉乡","140929206":"阳坪乡","140929207":"大涧乡","140929208":"宋家沟乡","140929209":"王家岔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140929.json
// module id = 355
// module chunks = 0